import { memo } from "react";
import { useSelector } from "react-redux";
import makeStyles from "@mui/styles/makeStyles";

import { palette } from "../../../theme/palette";

import { routeSelector } from "../../../reducers/matrixProfile/selectors";

import { TrolleyIcon } from "../../Icons";
import { View } from "../../View";

const useStyles = makeStyles({
  container: {
    pointerEvents: "none",
    width: "26px",
    height: "26px",
    lineHeight: "26px",
    fontSize: "0.75rem",
    textAlign: "center",
    borderRadius: "0.125rem",
    fontWeight: "bold",
    color: "white",
    cursor: "pointer",
    position: "relative",
  },
});

export const RouteLabel = memo(({ routeCode, collection = false }) => {
  const route = useSelector(routeSelector(routeCode));
  const styles = useStyles();

  return (
    <View
      style={{
        background: route?.colour || "black",
        color: route?.textColour || palette.typography.white.high,
      }}
      className={styles.container}
    >
      {collection ? <TrolleyIcon /> : routeCode || "?"}
    </View>
  );
});
